import moment from 'moment';
import React from 'react';
// Conference testimonials email with CPD
const NineStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    register_link,
    video_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      {/* <p>{client_name ? `Hi ${client_name},` : ` Hi [Recipient's Name],`}</p> */}

      <p>
        At IFERP, we’ve had the privilege of hosting numerous impactful
        conferences across the globe. Our attendees consistently share how our
        events have helped them grow, network, and gain valuable insights from
        experts in their fields.
      </p>
      <p>
        🌟 <strong>Here’s what some of them have to say</strong> 🌟{' '}
        {video_link ? (
          <>
            <a
              href={video_link}
              target="_blank"
              // rel="noopener noreferrer"
            >
              {video_link}
            </a>
          </>
        ) : (
          '[Video Link]'
        )}
      </p>
      <p>
        {conference_short_name
          ? conference_short_name
          : `[Conference Short Name]`}{' '}
        is CPD accredited, meaning you'll earn a globally recognized CPD
        certification, elevating your professional credentials.
      </p>

      <p>
        Don't miss your chance to be part of this exciting event. We’ve got an
        exciting lineup of speakers, sessions, and networking opportunities
        waiting for you.
      </p>

      <p>
        👉 Register Now:{' '}
        {register_link ? (
          <a
            href={register_link}
            target="_blank"
            // rel="noopener noreferrer"
          >
            {register_link}
          </a>
        ) : (
          ``
        )}
      </p>
      <p>
        Let me know if you have any questions or need assistance with
        registration. Looking forward to seeing you there!
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default NineStepWhatsappTemplate;
